<template>
  <div>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>
    <!-- v-if="!isSpinnerShow && totalEntries != 0" -->
    <div class="dataTables_wrapper dt-bootstrap4">
      <div class="row col-lg-12">
          <div
          v-for="item in rewardQRItems"
          class="col-md-4 p-2"
            :key="item.id">
            <b-card
            :title="item.title"
            :img-src="item.image"
            img-alt="Image"
            img-top
            tag="article"
            style="border-radius:25px;"
          >
            <b-card-text>
              {{item.topic}}
            </b-card-text>

            <!-- <b-button v-b-toggle.detail-sidebar variant="primary">View Details</b-button> -->
          </b-card>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import {
  handleSessionExpired,
  setReturnData,
  getOutletName,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "rewardQRList",
  data() {
    return {
      isSpinnerShow: false,
      filterObj: {},
      outlet: [],
      rewardQRItems: [],
      rewardQRData:[],
      exportData: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      delta: 0,
    };
  },
  computed: {
    exportField() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.username").toUpperCase()] = "username";
      ret[this.$i18n.t("table.header.outlet").toUpperCase()] = "outlet";
      ret[this.$i18n.t("table.header.working_hour").toUpperCase()] = "duration";
      ret[this.$i18n.t("table.header.clock_in").toUpperCase()] = "entryDate";
      ret[this.$i18n.t("table.header.clock_out").toUpperCase()] = "exitDate";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.setExportData(this.exportData);
    },
  },
  methods: {
    convertTimestampToDateTime(date) {
      return moment(date * 1000).format(this.$msg.CST.DATE_TIME_24);
    },
    getImage(img) {
      return img;
    },
    getDuration(strDuration) {
      var result = "";
      var arrDuration = strDuration.split(":");
      var hr = arrDuration[0];
      var min = arrDuration[1];

      if (hr.indexOf("-") != -1) {
        result = "Present";
      } else {
        hr = parseInt(hr);
        if (hr > 24) {
          var d = Math.floor(hr / 24);
          var rm = hr % 24;
          hr = Math.floor(rm);

          result = d + " Days " + hr + " Hr " + min + " Mins";
        } else {
          result = hr + " Hr " + min + " Mins";
        }
      }
      return result;
    },
    getOutletName(id) {
      return getOutletName(id, this.outlet);
    },
    async setRewardQRItems(filterObj) {
      this.filterObj = filterObj;
      var dateFilter = "";
      if (filterObj.dateType != "all") {
        dateFilter =
          filterObj.dateType == "entry"
            ? "&startEntryDate=" +
              moment(filterObj.date.startDate).unix() +
              "&endEntryDate=" +
              moment(filterObj.date.endDate).unix()
            : "&startExitDate=" +
              moment(filterObj.date.startDate).unix() +
              "&endExitDate=" +
              moment(filterObj.date.endDate).unix();
      } else {
        dateFilter =
          "&startCreateDate=" +
          1000000000 +
          "&endCreateDate=" +
          moment().endOf("month").unix();
      }


      this.isSpinnerShow = true;
      var retData = await this.getRewardQRItems();
      var result = setReturnData(retData, this.totalEntries, this.page);
      this.rewardQRItems = result.result;
      Object.assign(this.rewardQRData,this.rewardQRItems);
      this.totalPage = result.totalPage;

      this.startPage = result.startPage;
      this.endPage = result.endPage;
      this.isSpinnerShow = false;
      await this.getExportData();
    },
    async getRewardQRItems() {
      let $vm = this;
      let QUERY_STRING = this.$api.REWARDQR + "?delta=" + this.delta;
      const url = QUERY_STRING;

      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          let rewards = response.data.rewards;
          let skus = response.data.skus;
          let bcasts = response.data.bcasts;
          result = rewards.map((r) => ({
            ...r,
            ...bcasts.find((bcast) => bcast.bcastID === r.bcastID),
            ...skus.find((sku) => sku.skuID === r.skuID),
          }));
          $vm.totalEntries = result.length;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    async getExportData() {
      let $vm = this;
      let QUERY_STRING = this.$api.REWARDQR + "?delta=" + this.delta;
      const url = QUERY_STRING;
      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data;
          $vm.totalEntries = result.length;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.exportData = result;
      this.setExportData(result);
    },
    setExportData(data) {
      var strDate =
        moment(this.filterObj.date.startDate).format(
          this.$msg.CST.DATE_FORMAT
        ) +
        " - " +
        moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

      if (this.filterObj.dateType == "all") {
        strDate =
          " (" + this.$i18n.t("salon_report.rewardqr.all_date_types") + ")";
      } else {
        var dateType =
          this.$i18n.messages[this.$i18n.locale].salon_report.rewardqr
            .option_date_filter;
        var strDateType = dateType.filter(
          (obj) => obj.value == this.filterObj.dateType
        )[0].text;

        strDate =
          " (" +
          strDateType +
          ": " +
          moment(this.filterObj.date.startDate).format(
            this.$msg.CST.DATE_FORMAT
          ) +
          " - " +
          moment(this.filterObj.date.endDate).format(
            this.$msg.CST.DATE_FORMAT
          ) +
          ")";
      }

      let header =
        this.$msg.REPORT.HEADER +
        this.$i18n.t("subMenu.my_salon_rewardqr") +
        strDate;
      var exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];

      var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      var exportData = [];
      for (var i = 0; i < data.length; i++) {
        exportData.push({
          index: i + 1,
          name: data[i].name,
          username: data[i].username,
          outlet: this.getOutletName(data[i].outletID),
          entryDate: this.convertTimestampToDateTime(data[i].entryDate),
          exitDate:
            data[i].exitDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].exitDate),
        });
      }

      var exportObj = {
        data: exportData,
        fields: this.exportField,
        headers: exportHeaders,
        fileName: exportFileName,
      };

      this.$emit("setExportData", exportObj);
    },
    searchList(search){
      this.rewardQRItems.slice(0, this.rewardQRItems.length, ...this.rewardQRData);
      if(search != ""){
        this.rewardQRItems = this.rewardQRData.filter((item) => {
        if(Object.prototype.hasOwnProperty.call(item,'title') && Object.prototype.hasOwnProperty.call(item,'topic')){
          if (item.title.toUpperCase().includes(search.toUpperCase()) || item.topic.includes(search.toUpperCase())) {
          return item;
        }
        }
      });
      }
      else{
        this.rewardQRItems = this.rewardQRData;
      }
    },
    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.setRewardQRItems(this.filterObj);
      }
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);
  },
};
</script>
